import { PkDivider } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import { memo } from 'react';

import TeamIdentifier from '../Identifier/TeamIdentifier';

import type { Match } from '@shared-types/match.types';

const VsTeams = ({
  match,
  withDivider = true,
  invertSecondTeam = true,
  showTeamName = true,
  enableLink = true,
  className,
  classNameHome,
  classNameAway,
}: {
  match: Match;
  enableLink?: boolean;
  withDivider?: boolean;
  invertSecondTeam?: boolean;
  showTeamName?: boolean;
  className?: string;
  classNameHome?: string;
  classNameAway?: string;
}) => (
  <>
    <div className={clsx(className, 'vs-team')}>
      <div className={clsx(classNameHome, 'vs-team__home')}>
        <TeamIdentifier
          className='pk-py--0'
          team={match.homeTeam}
          enableLink={enableLink}
          badgeSize={32}
          showTeamCountry={false}
          showTeamName={showTeamName}
          phase={match?.round?.phase}
        />
      </div>
      <div className={clsx(classNameAway, 'vs-team__away')}>
        <TeamIdentifier
          className='pk-py--0'
          team={match.awayTeam}
          enableLink={enableLink}
          badgeSize={32}
          showTeamCountry={false}
          showTeamName={showTeamName}
          badgeSlot={invertSecondTeam ? 'suffix' : 'prefix'}
          phase={match?.round?.phase}
          alignment={invertSecondTeam ? 'right' : 'left'}
        />
      </div>
    </div>
    {withDivider && <PkDivider />}
  </>
);

export default memo(VsTeams);
